import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import { AttainmentBar } from 'ui-deal-management-components-lib/components/attainmentBar/AttainmentBar';
import { AttainmentBarNoGoalsTooltip } from './tooltips/AttainmentBarNoGoalsTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const AttainmentBarNoGoal = ({
  value,
  isDetailPage,
  subscreen,
  isDealStageView,
  teamId,
  onClickAttainmentBar,
  isLoadingGoal = false
}) => /*#__PURE__*/_jsx(AttainmentBar, {
  value: value.value,
  onClickAttainmentBar: onClickAttainmentBar,
  renderGoal: () => /*#__PURE__*/_jsx(AttainmentBarNoGoalsTooltip, {
    isDetailPage: isDetailPage,
    subscreen: subscreen,
    isDealStageView: isDealStageView,
    teamId: teamId,
    isLoadingGoal: isLoadingGoal
  }),
  renderValue: () => /*#__PURE__*/_jsx(FormattedIntlCurrency, {
    value: value.value,
    currencyCode: value.currencyCode
  })
});